import { simpleToken, getCountrys } from '@/api/mall/mallSystem'
import { listCategorySys } from '@/api/mall/mallGoods'
import { platformCoin } from '@/api/wallet/integral'
import { getConfig } from '@/api/mall/mallContent'
const state = {
  currentUrl: '', // 当前 Url
  areaCodeData: [], //区号列表
  qiNiuToken: '',//七牛云token


  // 系统分类相关
  classificationFirst: [],
  goodsCategorySysIdFirst: '',//一级分类
  goodsCategorySysIdSecond: '',//二级分类
  goodsCategorySysIdThird: '',//三级分类

  Pcoin: {}, // 平台金币信息
  h5Config: null,// 其他配置信息
}

const mutations = {
  open_new_page: (state, currentUrl) => {
    state.currentUrl = currentUrl
  },
  change_area_code_data: (state, areaCodeData) => {
    state.areaCodeData = areaCodeData
  },
}

const actions = {
  openNewPage: ({ commit }, currentUrl) => {
    commit('open_new_page', currentUrl)
  },
  changeAreaCodeData: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      getCountrys(params).then(res=>{
        commit('change_area_code_data', (res.data || []) )
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取七牛上传 token
  getQiNiuToken: ({ state }) => {
    return new Promise((resolve, reject) => {
      simpleToken().then(res=>{
        if(res.code===200){
          state.qiNiuToken = res.data.simpleUploadToken
        }
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },


  getListCategorySys: ({ state }, parentId)=>{
    return new Promise((resolve, reject) => {
      listCategorySys({categorySystem: 'NORMAL_MALL', parentId}).then(res=>{
        state.classificationFirst = res.data || []
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  change_goodsCategorySysIdFirst: ({ state }, id)=>{
    return new Promise((resolve, reject)=>{
      state.goodsCategorySysIdFirst = id
      resolve()
    })
  },
  change_goodsCategorySysIdSecond: ({ state }, id)=>{
    return new Promise((resolve, reject)=>{
      state.goodsCategorySysIdSecond = id
      resolve()
    })
  },
  change_goodsCategorySysIdThird: ({ state }, id)=>{
    return new Promise((resolve, reject)=>{
      state.goodsCategorySysIdThird = id
      resolve()
    })
  },
  change_categorySysId: ({ state }, arr)=>{
    return new Promise((resolve, reject)=>{
      state.goodsCategorySysIdFirst = arr[0]
      state.goodsCategorySysIdSecond = arr[1]
      state.goodsCategorySysIdThird = arr[2]
      resolve()
    })
  },

  // 获取平台金币价格
  getPlatformCoin: ({state, commit, dispatch}, req) => {
    return new Promise((resolve, reject) => {
      platformCoin(req).then(res=>{
        state.Pcoin = res.data
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取前端配置
  getConfig: ({state, commit, dispatch}, req) => {
    return new Promise((resolve, reject) => {
      getConfig(req).then(res=>{
        state.h5Config = res.data
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },


}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
